import { SET_ASSET_TYPE, RESET_ASSET_TYPE } from '../actions/types/AssetTypesActionTypes';
import { AUTH_LOGOUT } from '../../../redux/actions/types/authActionTypes';

const initialState = {
  appContext: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_ASSET_TYPE:
    return {
      ...state,
      appContext: action.payload.appContext,
    };
  case RESET_ASSET_TYPE:
    return {
      ...state,
      appContext: null,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};
